export const vehicleOfferPageLoadingKey = 'vehicleOfferPageOverlay';

export const emtyFilterState = {
  uds_carpolicynutzerid: null,
  uds_enginetypecode: null,
  uds_carbrandid: null,
  uds_signeeid: null,
  uds_carmodelid: null,
  uds_kstverantw: null,
  events: [],
  uds_carpolicyid: null,
  accountId: null,
  contactId: null,
  uds_name: null,
  uds_cost_centerid: null,
  employeeid: null
};

export const CRM_VALUE = {
  driverLevel: 'uds_carpolicynutzerid',
  engineType: 'uds_enginetypecode',
  manufacturer: 'uds_carbrandid',
  releaser: 'uds_signeeid',
  model: 'uds_carmodelid',
  responsiblePerson: 'uds_kstverantw',
  status: 'events',
  carPolicy: 'uds_carpolicyid',
  company: 'accountId',
  driver: 'contactId',
  offerNumber: 'uds_name',
  costCenter: 'uds_cost_centerid',
  employeeId: 'employeeid'
};
